import { render } from "./AlertBanner.vue?vue&type=template&id=814947e4"
import script from "./AlertBanner.vue?vue&type=script&lang=js"
export * from "./AlertBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__